module.exports = __webpack_public_path__ + "static/banner-tablet-cab369042e5e7c71150b8275b83e225c.png";